<template>
  <div class="nomal-combo">
    <div class="tuolele-main-box">
      <div class="data-form-title">设置套餐的具体内容</div>
      <el-form label-position="right" label-width="130px">
        <el-form-item label="套餐类型" required>
          <el-select
            v-model="item_type"
            placeholder="请选择"
            :disabled="isCreate"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置套餐详情" required>
          <div>
            <table>
              <tr>
                <td></td>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>赠送课时</td>
                <td>套餐（原价）</td>
                <td>
                  套餐（实际销售价）
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      <p class="el-tooltip__popper-text">
                        操作提示：
                        <br />1、常规套餐（实际销售价）和假期套餐（实际销售价），两者为必填项
                        <br />2、常规套餐（实际销售价）必须小于等于常规套餐（原价）
                        <br />3、假期套餐（实际销售价）必须小于等于假期套餐（原价
                      </p>
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </td>
              </tr>
              <tr v-if="item_type == 2 || item_type == 6 || item_type == 8">
                <td>假期</td>
                <td>日扣</td>
                <td>
                  <input
                    type="text"
                    v-model="holidayDayObj.holiday_day_time"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayDayObj.holiday_give_day_time"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
              <tr v-if="item_type == 1 || item_type == 6 || item_type == 7">
                <td>常规</td>
                <td>日扣</td>
                <td>
                  <input
                    type="text"
                    v-model="formalDayObj.formal_day_time"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalDayObj.give_day_time"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
              <tr v-if="item_type == 2 || item_type == 7 || item_type == 9">
                <td>假期</td>
                <td>月扣</td>
                <td>
                  <div>
                    <el-radio
                      v-model="holidayMonthCost"
                      label="1"
                      :disabled="isCreate"
                    >
                      <input
                        type="text"
                        v-model="holidayMonthObj.holiday_day"
                        placeholder="请输入"
                        :disabled="holidayMonthCost == 2 || isCreate"
                      />天
                    </el-radio>
                  </div>
                  <div>
                    <el-radio
                      v-model="holidayMonthCost"
                      label="2"
                      :disabled="isCreate"
                    >
                      <input
                        type="text"
                        v-model="holidayMonthObj.holiday_month"
                        placeholder="请输入"
                        :disabled="holidayMonthCost == 1 || isCreate"
                      />个月
                    </el-radio>
                  </div>
                  <p>(说明：1个月=30天)</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayMonthObj.holiday_give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayMonthObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayMonthObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
              <tr v-if="item_type == 1 || item_type == 8 || item_type == 9">
                <td>常规</td>
                <td>月扣</td>
                <td>
                  <div>
                    <el-radio
                      v-model="formalMonthCost"
                      label="1"
                      :disabled="isCreate"
                    >
                      <input
                        type="text"
                        v-model="formalMonthObj.formal_day"
                        placeholder="请输入"
                        :disabled="formalMonthCost == 2 || isCreate"
                      />天
                    </el-radio>
                  </div>
                  <div>
                    <el-radio
                      v-model="formalMonthCost"
                      label="2"
                      :disabled="isCreate"
                    >
                      <input
                        type="text"
                        v-model="formalMonthObj.formal_month"
                        placeholder="请输入"
                        :disabled="formalMonthCost == 1 || isCreate"
                      />个月
                    </el-radio>
                  </div>
                  <p>(说明：1个月=30天)</p>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalMonthObj.give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalMonthObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalMonthObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
               <tr v-if="item_type == 2">
                <td>假期</td>
                <td>周扣</td>
                <td>
                  <input
                    type="text"
                    v-model="holidayWeekDayObj.holiday_week_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayWeekDayObj.holiday_week_give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayWeekDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="holidayWeekDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
                  <tr v-if="item_type == 1">
                <td>常规</td>
                <td>周扣</td>
                <td>
                  <input
                    type="text"
                    v-model="weekDayObj.week_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="weekDayObj.week_give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="weekDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="weekDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
              <tr v-if="item_type == 31">
                <td>常规</td>
                <td>周末日扣</td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendDayObj.formal_weekend_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendDayObj.formal_weekend_give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
                <tr v-if="item_type == 41">
                <td>假期</td>
                <td>周末日扣</td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendHolidayDayObj.holiday_weekend_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendHolidayDayObj.holiday_weekend_give_day"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />天
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendHolidayDayObj.price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
                <td>
                  <input
                    type="text"
                    v-model="formalWeekendHolidayDayObj.real_price"
                    placeholder="请输入"
                    :disabled="isCreate"
                  />元
                </td>
              </tr>
            </table>
          </div>
        </el-form-item>
        <el-form-item label="赠送小学生课程"  class="xxs-form-box">
            <div class="wq_flex" v-for="(item,index) in xxsGiveLists">
               <el-form-item label="科目" style="width: 200px;margin-bottom:0px!important" class="" label-width="35px">
                    <Select style="width:140px"  :key="'give_subject'+index" :selected.sync="xxsGiveLists[index]['subject_id']" :data="subjectLists" clearable placeholder="请选择" />
                </el-form-item>
                 <el-form-item label="课时类型" style="width: 240px;margin-bottom:0px!important" class="" label-width="80px">
                    <Select style="width:140px" :key="'give_type'+ index" :selected.sync="xxsGiveLists[index]['course_type']" :data="xxsCourseLists" clearable placeholder="请选择" />
                </el-form-item>
                <el-form-item label="赠送课次" style="width: 240px;margin-bottom:0px!important" class="" label-width="80px">
                    <el-input-number style="width:140px" :key="'give_num'+ index" v-model="xxsGiveLists[index]['num']"  label="请输入数量"></el-input-number>
                </el-form-item>
                <el-form-item style="margin-bottom:0px!important" class="" >
                    <el-button style="width:70px;margin-left:10px" @click="fnDeleteXXSData(index)" type="danger" size="mini">删除</el-button>
                </el-form-item>
            </div>
            <el-button  icon="el-icon-plus" size="mini" @click="fnCreateXXSGiveList()" type="success" style="margin-top:10px">添加</el-button>
        </el-form-item>
        <el-form-item label="材料费"  >
          <el-input v-model="extra_price" placeholder="请输入材料费用" type='number'></el-input>
        </el-form-item>
        <el-form-item v-if="!isCreate">
          <el-button type="primary" @click="saveCombo">生成套餐</el-button>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br />1、请点击“生成套餐”按钮，系统将为您自动显示套餐详情
                <br />2、点击“修改套餐”按钮，可以继续编辑套餐详情
                <br />3、确认无误后，即可点击“提交套餐”按钮，系统将根据套餐预览详情，正式生成套餐！
              </p>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
    <div class="tuolele-main-box" v-if="isCreate">
      <div class="data-form-title">套餐详情预览</div>
      <div class="self-table">
        <div class="table-name">套餐名称 {{ comboShow.item_title }}</div>
        <div class="table-content">
          <table>
            <thead>
              <tr>
                <td></td>
                <td>扣费方式</td>
                <td>套餐课时</td>
                <td>赠送课时</td>
                <td>套餐（原价）</td>
                <td>套餐（实际销售价）</td>
                <td>日均课耗</td>
                <td>日均退费</td>
              </tr>
            </thead>
            <tbody>
              <tr v-if="item_type == 1 || item_type == 6 || item_type == 7">
                <td>常规</td>
                <td>日扣</td>
                <td>{{ formalDayObj.formal_day_time - 0 }}天</td>
                <td>{{ formalDayObj.give_day_time - 0 }}天</td>
                <td>{{ formalDayObj.price - 0 }}</td>
                <td>{{ formalDayObj.real_price - 0 }}</td>
                <td>{{ dayItemPrice }}</td>
                <td>{{ dayItemRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 2 || item_type == 6 || item_type == 8">
                <td>假期</td>
                <td>日扣</td>
                <td>{{ holidayDayObj.holiday_day_time - 0 }}天</td>
                <td>{{ holidayDayObj.holiday_give_day_time - 0 }}天</td>
                <td>{{ holidayDayObj.price - 0 }}</td>
                <td>{{ holidayDayObj.real_price - 0 }}</td>
                <td>{{ dayHolidayPrice }}</td>
                <td>{{ dayHolidayRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 1 || item_type == 8 || item_type == 9">
                <td>常规</td>
                <td>月扣</td>
                <td>
                  {{
                    formalMonthObj.formal_month * 30 +
                      (formalMonthObj.formal_day - 0)
                  }}天
                </td>
                <td>{{ formalMonthObj.give_day - 0 }}天</td>
                <td>{{ formalMonthObj.price - 0 }}</td>
                <td>{{ formalMonthObj.real_price - 0 }}</td>
                <td>{{ monthItemPrice }}</td>
                <td>{{ monthItemRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 2 || item_type == 7 || item_type == 9">
                <td>假期</td>
                <td>月扣</td>
                <td>
                  {{
                    holidayMonthObj.holiday_month * 30 +
                      (holidayMonthObj.holiday_day - 0)
                  }}天
                </td>
                <td>{{ holidayMonthObj.holiday_give_day - 0 }}天</td>
                <td>{{ holidayMonthObj.price - 0 }}</td>
                <td>{{ holidayMonthObj.real_price - 0 }}</td>
                <td>{{ monthHolidayPrice }}</td>
                <td>{{ monthHolidayRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 1">
                <td>常规</td>
                <td>周扣</td>
                <td>{{ weekDayObj.week_day - 0 }}天</td>
                <td>{{ weekDayObj.week_give_day - 0 }}天</td>
                <td>{{ weekDayObj.price - 0 }}</td>
                <td>{{ weekDayObj.real_price - 0 }}</td>
                <td>{{ weekItemPrice }}</td>
                <td>{{ weekItemRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 31">
                <td>常规</td>
                <td>周末日扣</td>
                 <td>{{ formalWeekendDayObj.formal_weekend_day - 0 }}天</td>
                <td>{{ formalWeekendDayObj.formal_weekend_give_day - 0 }}天</td>
                <td>{{ formalWeekendDayObj.price - 0 }}</td>
                <td>{{ formalWeekendDayObj.real_price - 0 }}</td>
                <td>{{ formalWeekendItemPrice }}</td>
                <td>{{ formalWeekendItemRefundPrice }}</td>
              </tr>
              <tr v-if="item_type == 41">
                <td>假期</td>
                <td>周末日扣</td>
                 <td>{{ formalWeekendHolidayDayObj.holiday_weekend_day - 0 }}天</td>
                <td>{{ formalWeekendHolidayDayObj.holiday_weekend_give_day - 0 }}天</td>
                <td>{{ formalWeekendHolidayDayObj.price - 0 }}</td>
                <td>{{ formalWeekendHolidayDayObj.real_price - 0 }}</td>
                <td>{{ formalWeekendHolidayPrice }}</td>
                <td>{{ formalWeekendHolidayRefundPrice }}</td>
              </tr>
               <tr v-if="item_type == 2">
                <td>假期</td>
                <td>周扣</td>
                <td>{{ holidayWeekDayObj.holiday_week_day - 0 }}天</td>
                <td>{{ holidayWeekDayObj.holiday_week_give_day - 0 }}天</td>
                <td>{{ holidayWeekDayObj.price - 0 }}</td>
                <td>{{ holidayWeekDayObj.real_price - 0 }}</td>
                <td>{{ weekHolidayPrice }}</td>
                <td>{{ weekHolidayRefundPrice }}</td>
              </tr>
            </tbody>
          </table>
          <div class="xxs_preview" v-if="comboShow.combineLists.length>0">
            <h4>小学生赠送</h4>
            <div class="wq_flex" v-for="(item,index) in comboShow.combineLists">
              <div class="wq_flex_sub">科目:{{fnFindSubjectId(item.subject_id)}}</div>
               <div class="wq_flex_sub">类型:{{fnFindCourseType(item.course_type)}}</div>
                <div class="wq_flex_sub">赠送数:{{item.num}}</div>
            </div>
          </div>
          <div class="xxs_preview" v-if="extra_price">
            <h4>材料费:  {{extra_price}}元</h4>            
          </div>
        </div>
        <el-button type="info" @click="isCreate = false">修改套餐</el-button>
        <el-button type="primary" @click="postCombo">提交套餐</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'


export default {
  name: "nomalCombo",
  components: {
    Select
  },
  props: {
    type: [String, Number],
    item_title: String,
    limited_number: [String, Number],
    grade_id: String,
    is_supplementary_agreement: [String, Number],
  },
  data() {
    return {
      typeList: [
        { text: "常规", value: "1" },
        { text: "假期", value: "2" },
        //{ text: "常日+假日", value: "6" },
        //{ text: "常日+假月", value: "7" },
        //{ text: "常月+假日", value: "8" },
        //{ text: "常月+假月", value: "9" },
        { text: "常规周末", value: "31" },
        { text: "假期周末", value: "41" }
      ],
      subjectLists: commondata.XXS_SUBJECT_LISTS,
      xxsCourseLists: commondata.XXS_COURSE_TYPE,
      formalMonthCost: "1",
      holidayMonthCost: "1",
      item_type: "1",
      extra_price:'',
      formalMonthObj: {
        formal_month: "",
        formal_day: "",
        give_day: "",
        price: "",
        real_price: ""
      },
      holidayMonthObj: {
        holiday_month: "",
        holiday_day: "",
        holiday_give_day: "",
        price: "",
        real_price: ""
      },
      formalDayObj: {
        formal_day_time: "",
        give_day_time: "",
        price: "",
        real_price: ""
      },
      formalWeekendDayObj: {
        formal_weekend_day: "",
        formal_weekend_give_day: "",
        price: "",
        real_price: ""
      },
      formalWeekendHolidayDayObj: {
        holiday_weekend_day: "",
        holiday_weekend_give_day: "",
        price: "",
        real_price: ""
      },
       holidayDayObj: {
        holiday_day_time: "",
        holiday_give_day_time: "",
        price: "",
        real_price: ""
      },
      xxsGiveLists: [],
      weekDayObj: {
        price: "",
        real_price: "",
        week_day: "",
        week_give_day: "",
      },
      holidayWeekDayObj: {
        holiday_week_day: "",
        holiday_week_give_day: "",
        price: "",
        real_price: "",
      },
      comboShow: {
        type: "",
        item_title: "",
        limited_number: "",
        grade_id: "",
        item_type: "",
        total_price: "",
        is_supplementary_agreement: "",
        original_price: "",
       
      },
      isCreate: false
    };
  },
  computed: {
    dayItemPrice() {
      if (this.formalDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalDayObj.real_price - 0) /
            (this.formalDayObj.formal_day_time -
              0 +
              (this.formalDayObj.give_day_time - 0))
        );
      }
    },
    dayItemRefundPrice() {
      if (this.formalDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalDayObj.price - 0) /
            (this.formalDayObj.formal_day_time - 0)
        );
      }
    },
   
    dayHolidayPrice() {
      if (this.holidayDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayDayObj.real_price - 0) /
            (this.holidayDayObj.holiday_day_time -
              0 +
              (this.holidayDayObj.holiday_give_day_time - 0))
        );
      }
    },
    dayHolidayRefundPrice() {
      if (this.holidayDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayDayObj.price - 0) /
            (this.holidayDayObj.holiday_day_time - 0)
        );
      }
    },
    weekItemPrice() {
      if (this.weekDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.weekDayObj.real_price - 0) /
            (this.weekDayObj.week_day -
              0 +
              (this.weekDayObj.week_give_day - 0))
        );
      }
    },
    formalWeekendItemPrice() {
       if (this.formalWeekendDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendDayObj.real_price - 0) /
            (this.formalWeekendDayObj.formal_weekend_day -
              0 +
              (this.formalWeekendDayObj.formal_weekend_give_day - 0))
        );
      }
    },
    formalWeekendItemRefundPrice() {
      if (this.formalWeekendDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendDayObj.price - 0) /
            (this.formalWeekendDayObj.formal_weekend_day - 0)
        );
      }
    },
     formalWeekendHolidayPrice() {
      if (this.formalWeekendHolidayDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendHolidayDayObj.real_price - 0) /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day -
              0 +
              (this.formalWeekendHolidayDayObj.holiday_weekend_give_day - 0))
        );
      }
    },
    formalWeekendHolidayRefundPrice() {
      if (this.formalWeekendHolidayDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalWeekendHolidayDayObj.price - 0) /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day - 0)
        );
      }
    },
    weekItemRefundPrice() {
      if (this.weekDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.weekDayObj.price - 0) /
            (this.weekDayObj.week_day - 0)
        );
      }
    },
      weekHolidayPrice() {
      if (this.holidayWeekDayObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayWeekDayObj.real_price - 0) /
            (this.holidayWeekDayObj.holiday_week_day -
              0 +
              (this.holidayWeekDayObj.holiday_week_give_day - 0))
        );
      }
    },


    weekHolidayRefundPrice() {
      if (this.holidayWeekDayObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayWeekDayObj.price - 0) /
            (this.holidayWeekDayObj.holiday_week_day - 0)
        );
      }
    },
    monthItemPrice() {
      if (this.formalMonthObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalMonthObj.real_price - 0) /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0) +
              (this.formalMonthObj.give_day - 0))
        );
      }
    },
    monthItemRefundPrice() {
      if (this.formalMonthObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.formalMonthObj.price - 0) /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0))
        );
      }
    },
    monthHolidayPrice() {
      if (this.holidayMonthObj.real_price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayMonthObj.real_price - 0) /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0) +
              (this.holidayMonthObj.holiday_give_day - 0))
        );
      }
    },
    monthHolidayRefundPrice() {
      if (this.holidayMonthObj.price == 0) {
        return 0;
      } else {
        return Tool.calcuateMoney(
          (this.holidayMonthObj.price - 0) /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0))
        );
      }
    }
  },
  mounted() {},
  methods: {
    async postCombo() {
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.is_supplementary_agreement = this.is_supplementary_agreement;
      this.comboShow.item_type = this.item_type;
      if (this.comboShow.combineLists.length>0) {
        this.comboShow.combineJson = JSON.stringify(this.comboShow.combineLists)
      }
      if(this.extra_price) {
          this.comboShow.extra_product = JSON.stringify([{
              classify_type: 'materials',
              value: this.extra_price
          }])
      }

      let ret = await this.$http.improveItem(this.comboShow);
      if (ret.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.$router.go(-1);
      }
    },
    saveCombo() {
      if (this.item_title == "") {
        this.$message({
          message: "套餐名称不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.grade_id == "") {
        this.$message({
          message: "请选择适用年级",
          type: "warning"
        });
        return false;
      }
      this.comboShow = {
        type: "",
        item_title: "",
        limited_number: "",
        grade_id: "",
        item_type: "",
        total_price: "",
        combineLists: this.xxsGiveLists,
      };

      if (this.item_type == 1 ) {
        this.saveNormalCombo();
      } else if (this.item_type == 2 || this.item_type == 41) {
        this.saveHolidayCombo();
      } else if (this.item_type == 6) {
        this.saveFDayHDayCombo();
      } else if (this.item_type == 7) {
        this.saveFDayHMonthCombo();
      } else if (this.item_type == 8) {
        this.saveFMonthHDayCombo();
      } else if (this.item_type == 9) {
        this.saveFMonthHMonthCombo();
      } else {
        this.saveNormalCombo();
      }
    },
    saveNormalCombo() {
     const isAllFilled = (obj) => Object.values(obj).every(val => val !== '')

      const flag1 = isAllFilled(this.formalDayObj)
      const flag3 = isAllFilled(this.weekDayObj)
      const flag4 = isAllFilled(this.formalWeekendDayObj)
      const flag5 = isAllFilled(this.formalWeekendHolidayDayObj)

      const { formal_month, formal_day, ...restMonth } = this.formalMonthObj
      const flag2 = (formal_month !== '' || formal_day !== '') && isAllFilled(restMonth)

      if (flag1 && flag2) {
        this.$message({
          message: '不能生成常规日+常规月的套餐类型',
          type: 'warning'
        })
        return false
      }
      if ((flag1 || flag2 || flag3) && flag4) {
        this.$message({
          message: '不能生成周末课时+周中课时套餐',
          type: 'warning'
        })
        return false
      }

      if (!flag1 && !flag2 && !flag3 && !flag4 && !flag5) {
        this.$message({
          message: '请将套餐信息填写完整',
          type: 'warning'
        })
        return false
      }
      this.comboShow.type = this.type
      this.comboShow.item_title = this.item_title
      this.comboShow.grade_id = this.grade_id
      this.comboShow.limited_number = this.limited_number
      this.comboShow.item_type = this.item_type
      if (flag1) {
        let empty = false
        for (const key in this.formalDayObj) {
          if (this.formalDayObj.hasOwnProperty(key)) {
            if (this.formalDayObj[key] == '') {
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.formalDayObj.real_price /
            (this.formalDayObj.formal_day_time -
              0 +
              (this.formalDayObj.give_day_time - 0))
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.formalDayObj.price / (this.formalDayObj.formal_day_time - 0)
        )
        this.comboShow.formal_day_time = this.formalDayObj.formal_day_time
        this.comboShow.give_day_time = this.formalDayObj.give_day_time
        this.comboShow.total_price = this.formalDayObj.real_price
        this.comboShow.original_price = this.formalDayObj.price
        this.comboShow.item_total_price = this.formalDayObj.real_price
      }
      if (flag2) {
        let empty = false
        for (const key in this.formalMonthObj) {
          if (this.formalMonthObj.hasOwnProperty(key)) {
            if (this.formalMonthObj[key] == '') {
              if (
                key == 'formal_month' &&
                this.formalMonthObj.formal_day != ''
              ) {
                continue
              }
              if (
                key == 'formal_day' &&
                this.formalMonthObj.formal_month != ''
              ) {
                continue
              }
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.formalMonthObj.real_price /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0) +
              (this.formalMonthObj.give_day - 0))
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.formalMonthObj.price /
            (this.formalMonthObj.formal_month * 30 +
              (this.formalMonthObj.formal_day - 0))
        )
        this.comboShow.formal_month = this.formalMonthObj.formal_month
        this.comboShow.formal_day = this.formalMonthObj.formal_day
        this.comboShow.give_day = this.formalMonthObj.give_day
        this.comboShow.total_price = this.formalMonthObj.real_price
        this.comboShow.original_price = this.formalMonthObj.price
        this.comboShow.item_total_price = this.formalMonthObj.real_price
      }
      if (flag3) {
        let empty = false
        for (const key in this.weekDayObj) {
          if (this.formalDayObj.hasOwnProperty(key)) {
            if (this.weekDayObj[key] == '') {
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.weekDayObj.real_price /
            (this.weekDayObj.week_day -
              0 +
              (this.weekDayObj.week_give_day - 0))
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.weekDayObj.price / (this.weekDayObj.week_day - 0)
        )
        this.comboShow.week_day = this.weekDayObj.week_day
        this.comboShow.week_give_day = this.weekDayObj.week_give_day
        this.comboShow.total_price = this.weekDayObj.real_price
        this.comboShow.original_price = this.weekDayObj.price
        this.comboShow.item_total_price = this.weekDayObj.real_price
      }

      if (flag4) {
        let empty = false
        for (const key in this.formalWeekendDayObj) {
          if (this.formalWeekendDayObj.hasOwnProperty(key)) {
            if (this.formalWeekendDayObj[key] == '') {
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.formalWeekendDayObj.real_price /
            (this.formalWeekendDayObj.formal_weekend_day -
              0 +
              (this.formalWeekendDayObj.formal_weekend_give_day - 0))
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.formalWeekendDayObj.price / (this.formalWeekendDayObj.formal_weekend_day - 0)
        )
        this.comboShow.formal_weekend_day = this.formalWeekendDayObj.formal_weekend_day
        this.comboShow.formal_weekend_give_day = this.formalWeekendDayObj.formal_weekend_give_day
        this.comboShow.total_price = this.formalWeekendDayObj.real_price
        this.comboShow.original_price = this.formalWeekendDayObj.price
        this.comboShow.item_total_price = this.formalWeekendDayObj.real_price
      }
      if (flag5) {
      console.log(this.formalWeekendHolidayDayObj)
       let empty = false
        for (const key in this.formalWeekendHolidayDayObj) {
          if (this.formalWeekendHolidayDayObj.hasOwnProperty(key)) {
            if (this.formalWeekendHolidayDayObj[key] == '') {
              empty = true
            }
          }
        }
        if (empty) {
          this.$message({
            message: '请将套餐信息填写完整',
            type: 'warning'
          })
          return false
        }
        this.comboShow.item_price = Tool.calcuateMoney(
          this.formalWeekendHolidayDayObj.real_price /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day -
              0 +
              (this.formalWeekendHolidayDayObj.holiday_weekend_give_day - 0))
        )
        this.comboShow.item_refund_price = Tool.calcuateMoney(
          this.formalWeekendHolidayDayObj.price / (this.formalWeekendHolidayDayObj.holiday_weekend_day - 0)
        )
        this.comboShow.holiday_weekend_day = this.formalWeekendHolidayDayObj.holiday_weekend_day
        this.comboShow.holiday_weekend_give_day = this.formalWeekendHolidayDayObj.holiday_weekend_give_day
        this.comboShow.total_price = this.formalWeekendHolidayDayObj.real_price
        this.comboShow.original_price = this.formalWeekendHolidayDayObj.price
        this.comboShow.item_total_price = this.formalWeekendHolidayDayObj.real_price
      }


      this.isCreate = true
    },
    saveHolidayCombo() {
      let flag1 = false;
      let flag2 = false;
      let flag3 = false;
      let flag4 = false;
      for (const key in this.holidayDayObj) {
        if (this.holidayDayObj.hasOwnProperty(key)) {
          if (this.holidayDayObj[key] != "") {
            flag1 = true;
          }
        }
      }
      for (const key in this.holidayMonthObj) {
        if (this.holidayMonthObj.hasOwnProperty(key)) {
          if (this.holidayMonthObj[key] != "") {
            flag2 = true;
          }
        }
      }
      for (const key in this.holidayWeekDayObj) {
        if (this.holidayWeekDayObj.hasOwnProperty(key)) {
          if (this.holidayWeekDayObj[key] != "") {
            flag3 = true;
          }
        }
      }
       for (const key in this.formalWeekendHolidayDayObj) {
        if (this.formalWeekendHolidayDayObj.hasOwnProperty(key)) {
          if (this.formalWeekendHolidayDayObj[key] != "") {
            flag4 = true;
          }
        }
      }
      if (flag1 && flag2) {
        this.$message({
          message: "不能生成假期日+假期月的套餐类型",
          type: "warning"
        });
        return false;
      }
      if (!flag1 && !flag2 && !flag3 && !flag4) {
        this.$message({
          message: "请将套餐信息填写完整",
          type: "warning"
        });
        return false;
      }
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.item_type = this.item_type;
      if (flag1) {
        let empty = false;
        for (const key in this.holidayDayObj) {
          if (this.holidayDayObj.hasOwnProperty(key)) {
            if (this.holidayDayObj[key] == "") {
              empty = true;
            }
          }
        }
        if (empty) {
          this.$message({
            message: "请将套餐信息填写完整",
            type: "warning"
          });
          return false;
        }
        this.comboShow.holiday_price = Tool.calcuateMoney(
          this.holidayDayObj.real_price /
            (this.holidayDayObj.holiday_day_time -
              0 +
              (this.holidayDayObj.holiday_give_day_time - 0))
        );
        this.comboShow.holiday_refund_price = Tool.calcuateMoney(
          this.holidayDayObj.price / (this.holidayDayObj.holiday_day_time - 0)
        );
        this.comboShow.holiday_day_time = this.holidayDayObj.holiday_day_time;
        this.comboShow.holiday_give_day_time = this.holidayDayObj.holiday_give_day_time;
        this.comboShow.total_price = this.holidayDayObj.real_price;
        this.comboShow.original_price = this.holidayDayObj.price;
        this.comboShow.holiday_total_price = this.holidayDayObj.real_price;
      }
      if (flag2) {
        let empty = false;
        for (const key in this.holidayMonthObj) {
          if (this.holidayMonthObj.hasOwnProperty(key)) {
            if (this.holidayMonthObj[key] == "") {
              if (
                key == "holiday_month" &&
                this.holidayMonthObj.holiday_day != ""
              ) {
                continue;
              }
              if (
                key == "holiday_day" &&
                this.holidayMonthObj.holiday_month != ""
              ) {
                continue;
              }
              empty = true;
            }
          }
        }
        if (empty) {
          this.$message({
            message: "请将套餐信息填写完整",
            type: "warning"
          });
          return false;
        }
        this.comboShow.holiday_price = Tool.calcuateMoney(
          this.holidayMonthObj.real_price /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0) +
              (this.holidayMonthObj.holiday_give_day - 0))
        );
        this.comboShow.holiday_refund_price = Tool.calcuateMoney(
          this.holidayMonthObj.price /
            (this.holidayMonthObj.holiday_month * 30 +
              (this.holidayMonthObj.holiday_day - 0))
        );
        this.comboShow.holiday_month = this.holidayMonthObj.holiday_month;
        this.comboShow.holiday_day = this.holidayMonthObj.holiday_day;
        this.comboShow.holiday_give_day = this.holidayMonthObj.holiday_give_day;
        this.comboShow.total_price = this.holidayMonthObj.real_price;
        this.comboShow.original_price = this.holidayMonthObj.price;
        this.comboShow.holiday_total_price = this.holidayMonthObj.real_price;
      }

       if (flag3) {
        let empty = false;
        for (const key in this.holidayWeekDayObj) {
          if (this.holidayDayObj.hasOwnProperty(key)) {
            if (this.holidayWeekDayObj[key] == "") {
              empty = true;
            }
          }
        }
        if (empty) {
          this.$message({
            message: "请将套餐信息填写完整",
            type: "warning"
          });
          return false;
        }
        this.comboShow.holiday_price = Tool.calcuateMoney(
          this.holidayWeekDayObj.real_price /
            (this.holidayWeekDayObj.holiday_week_day -
              0 +
              (this.holidayWeekDayObj.holiday_week_give_day - 0))
        );
        this.comboShow.holiday_refund_price = Tool.calcuateMoney(
          this.holidayWeekDayObj.price / (this.holidayWeekDayObj.holiday_week_day - 0)
        );
        this.comboShow.holiday_week_day = this.holidayWeekDayObj.holiday_week_day;
        this.comboShow.holiday_week_give_day = this.holidayWeekDayObj.holiday_week_give_day;
        this.comboShow.total_price = this.holidayWeekDayObj.real_price;
        this.comboShow.original_price = this.holidayWeekDayObj.price;
        this.comboShow.holiday_total_price = this.holidayWeekDayObj.real_price;
      }

      if (flag4) {
        let empty = false;
        for (const key in this.formalWeekendHolidayDayObj) {
          if (this.formalWeekendHolidayDayObj.hasOwnProperty(key)) {
            if (this.formalWeekendHolidayDayObj[key] == "") {
              empty = true;
            }
          }
        }
        if (empty) {
          this.$message({
            message: "请将套餐信息填写完整",
            type: "warning"
          });
          return false;
        }
        this.comboShow.holiday_price = Tool.calcuateMoney(
          this.formalWeekendHolidayDayObj.real_price /
            (this.formalWeekendHolidayDayObj.holiday_weekend_day -
              0 +
              (this.formalWeekendHolidayDayObj.holiday_weekend_give_day - 0))
        );
        this.comboShow.holiday_refund_price = Tool.calcuateMoney(
          this.formalWeekendHolidayDayObj.price / (this.formalWeekendHolidayDayObj.holiday_weekend_day - 0)
        );
        this.comboShow.holiday_weekend_day = this.formalWeekendHolidayDayObj.holiday_weekend_day;
        this.comboShow.holiday_weekend_give_day = this.formalWeekendHolidayDayObj.holiday_weekend_give_day;
        this.comboShow.total_price = this.formalWeekendHolidayDayObj.real_price;
        this.comboShow.original_price = this.formalWeekendHolidayDayObj.price;
        this.comboShow.holiday_total_price = this.formalWeekendHolidayDayObj.real_price;
      }
      
      this.isCreate = true;
    },
    saveFDayHDayCombo() {
      let empty1 = false;
      let empty2 = false;
      for (const key in this.formalDayObj) {
        if (this.formalDayObj.hasOwnProperty(key)) {
          if (this.formalDayObj[key] == "") {
            empty1 = true;
          }
        }
      }
      for (const key in this.holidayDayObj) {
        if (this.holidayDayObj.hasOwnProperty(key)) {
          if (this.holidayDayObj[key] == "") {
            empty2 = true;
          }
        }
      }
      if (empty1 || empty2) {
        this.$message({
          message: "请将套餐信息填写完整",
          type: "warning"
        });
        return false;
      }
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.item_type = this.item_type;
      this.comboShow.item_price = Tool.calcuateMoney(
        this.formalDayObj.real_price /
          (this.formalDayObj.formal_day_time -
            0 +
            (this.formalDayObj.give_day_time - 0))
      );
      this.comboShow.item_refund_price = Tool.calcuateMoney(
        this.formalDayObj.price / (this.formalDayObj.formal_day_time - 0)
      );
      this.comboShow.formal_day_time = this.formalDayObj.formal_day_time;
      this.comboShow.give_day_time = this.formalDayObj.give_day_time;
      this.comboShow.holiday_price = Tool.calcuateMoney(
        this.holidayDayObj.real_price /
          (this.holidayDayObj.holiday_day_time -
            0 +
            (this.holidayDayObj.holiday_give_day_time - 0))
      );
      this.comboShow.holiday_refund_price = Tool.calcuateMoney(
        this.holidayDayObj.price / (this.holidayDayObj.holiday_day_time - 0)
      );
      this.comboShow.holiday_day_time = this.holidayDayObj.holiday_day_time;
      this.comboShow.holiday_give_day_time = this.holidayDayObj.holiday_give_day_time;
      this.comboShow.total_price =
        this.holidayDayObj.real_price - 0 + (this.formalDayObj.real_price - 0);
      this.comboShow.original_price =
        this.holidayDayObj.price - 0 + (this.formalDayObj.price - 0);
      this.comboShow.item_total_price = this.formalDayObj.real_price;
      this.comboShow.holiday_total_price = this.holidayDayObj.real_price;
      this.isCreate = true;
    },
    saveFDayHMonthCombo() {
      let empty1 = false;
      let empty2 = false;
      for (const key in this.formalDayObj) {
        if (this.formalDayObj.hasOwnProperty(key)) {
          if (this.formalDayObj[key] == "") {
            empty1 = true;
          }
        }
      }
      for (const key in this.holidayMonthObj) {
        if (this.holidayMonthObj.hasOwnProperty(key)) {
          if (this.holidayMonthObj[key] == "") {
            if (
              key == "holiday_month" &&
              this.holidayMonthObj.holiday_day != ""
            ) {
              continue;
            }
            if (
              key == "holiday_day" &&
              this.holidayMonthObj.holiday_month != ""
            ) {
              continue;
            }
            empty2 = true;
          }
        }
      }
      if (empty1 || empty2) {
        this.$message({
          message: "请将套餐信息填写完整",
          type: "warning"
        });
        return false;
      }
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.item_type = this.item_type;
      this.comboShow.item_price = Tool.calcuateMoney(
        this.formalDayObj.real_price /
          (this.formalDayObj.formal_day_time -
            0 +
            (this.formalDayObj.give_day_time - 0))
      );
      this.comboShow.item_refund_price = Tool.calcuateMoney(
        this.formalDayObj.price / (this.formalDayObj.formal_day_time - 0)
      );
      this.comboShow.formal_day_time = this.formalDayObj.formal_day_time;
      this.comboShow.give_day_time = this.formalDayObj.give_day_time;
      this.comboShow.holiday_price = Tool.calcuateMoney(
        this.holidayMonthObj.real_price /
          (this.holidayMonthObj.holiday_month * 30 +
            (this.holidayMonthObj.holiday_day - 0) +
            (this.holidayMonthObj.holiday_give_day - 0))
      );
      this.comboShow.holiday_refund_price = Tool.calcuateMoney(
        this.holidayMonthObj.price /
          (this.holidayMonthObj.holiday_month * 30 +
            (this.holidayMonthObj.holiday_day - 0))
      );
      this.comboShow.holiday_month = this.holidayMonthObj.holiday_month;
      this.comboShow.holiday_day = this.holidayMonthObj.holiday_day;
      this.comboShow.holiday_give_day = this.holidayMonthObj.holiday_give_day;
      this.comboShow.total_price =
        this.holidayMonthObj.real_price -
        0 +
        (this.formalDayObj.real_price - 0);
      this.comboShow.item_total_price = this.formalDayObj.real_price;
      this.comboShow.holiday_total_price = this.holidayMonthObj.real_price;
      this.isCreate = true;
    },
    saveFMonthHDayCombo() {
      let empty1 = false;
      let empty2 = false;
      for (const key in this.formalMonthObj) {
        if (this.formalMonthObj.hasOwnProperty(key)) {
          if (this.formalMonthObj[key] == "") {
            if (key == "formal_month" && this.formalMonthObj.formal_day != "") {
              continue;
            }
            if (key == "formal_day" && this.formalMonthObj.formal_month != "") {
              continue;
            }
            empty1 = true;
          }
        }
      }
      for (const key in this.holidayDayObj) {
        if (this.holidayDayObj.hasOwnProperty(key)) {
          if (this.holidayDayObj[key] == "") {
            empty2 = true;
          }
        }
      }
      if (empty1 || empty2) {
        this.$message({
          message: "请将套餐信息填写完整",
          type: "warning"
        });
        return false;
      }
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.item_type = this.item_type;
      this.comboShow.item_price = Tool.calcuateMoney(
        this.formalMonthObj.real_price /
          (this.formalMonthObj.formal_month * 30 +
            (this.formalMonthObj.formal_day - 0) +
            (this.formalMonthObj.give_day - 0))
      );
      this.comboShow.item_refund_price = Tool.calcuateMoney(
        this.formalMonthObj.price /
          (this.formalMonthObj.formal_month * 30 +
            (this.formalMonthObj.formal_day - 0))
      );
      this.comboShow.formal_month = this.formalMonthObj.formal_month;
      this.comboShow.formal_day = this.formalMonthObj.formal_day;
      this.comboShow.give_day = this.formalMonthObj.give_day;
      this.comboShow.holiday_price = Tool.calcuateMoney(
        this.holidayDayObj.real_price /
          (this.holidayDayObj.holiday_day_time -
            0 +
            (this.holidayDayObj.holiday_give_day_time - 0))
      );
      this.comboShow.holiday_refund_price = Tool.calcuateMoney(
        this.holidayDayObj.price / (this.holidayDayObj.holiday_day_time - 0)
      );
      this.comboShow.holiday_day_time = this.holidayDayObj.holiday_day_time;
      this.comboShow.holiday_give_day_time = this.holidayDayObj.holiday_give_day_time;
      this.comboShow.total_price =
        this.holidayDayObj.real_price -
        0 +
        (this.formalMonthObj.real_price - 0);
      this.comboShow.item_total_price = this.formalMonthObj.real_price;
      this.comboShow.holiday_total_price = this.holidayDayObj.real_price;
      this.isCreate = true;
    },
    calcuateMoney:function(num) {
       return ( num && num > 0 ) ? Math.floor(num*100)/100 : 0
    },
    saveFMonthHMonthCombo() {
      let empty1 = false;
      let empty2 = false;
      for (const key in this.formalMonthObj) {
        if (this.formalMonthObj.hasOwnProperty(key)) {
          if (this.formalMonthObj[key] == "") {
            if (key == "formal_month" && this.formalMonthObj.formal_day != "") {
              continue;
            }
            if (key == "formal_day" && this.formalMonthObj.formal_month != "") {
              continue;
            }
            empty1 = true;
          }
        }
      }
      for (const key in this.holidayMonthObj) {
        if (this.holidayMonthObj.hasOwnProperty(key)) {
          if (this.holidayMonthObj[key] == "") {
            if (
              key == "holiday_month" &&
              this.holidayMonthObj.holiday_day != ""
            ) {
              continue;
            }
            if (
              key == "holiday_day" &&
              this.holidayMonthObj.holiday_month != ""
            ) {
              continue;
            }
            empty2 = true;
          }
        }
      }
      if (empty1 || empty2) {
        this.$message({
          message: "请将套餐信息填写完整",
          type: "warning"
        });
        return false;
      }
      this.comboShow.type = this.type;
      this.comboShow.item_title = this.item_title;
      this.comboShow.grade_id = this.grade_id;
      this.comboShow.limited_number = this.limited_number;
      this.comboShow.item_type = this.item_type;
      this.comboShow.item_price = Tool.calcuateMoney(
        this.formalMonthObj.real_price /
          (this.formalMonthObj.formal_month * 30 +
            (this.formalMonthObj.formal_day - 0) +
            (this.formalMonthObj.give_day - 0))
      );
      this.comboShow.item_refund_price = Tool.calcuateMoney(
        this.formalMonthObj.price /
          (this.formalMonthObj.formal_month * 30 +
            (this.formalMonthObj.formal_day - 0))
      );
      this.comboShow.formal_month = this.formalMonthObj.formal_month;
      this.comboShow.formal_day = this.formalMonthObj.formal_day;
      this.comboShow.give_day = this.formalMonthObj.give_day;
      this.comboShow.holiday_price = Tool.calcuateMoney(
        this.holidayMonthObj.real_price /
          (this.holidayMonthObj.holiday_month * 30 +
            (this.holidayMonthObj.holiday_day - 0) +
            (this.holidayMonthObj.holiday_give_day - 0))
      );
      this.comboShow.holiday_refund_price = Tool.calcuateMoney(
        this.holidayMonthObj.price /
          (this.holidayMonthObj.holiday_month * 30 +
            (this.holidayMonthObj.holiday_day - 0))
      );
      this.comboShow.holiday_month = this.holidayMonthObj.holiday_month;
      this.comboShow.holiday_day = this.holidayMonthObj.holiday_day;
      this.comboShow.holiday_give_day = this.holidayMonthObj.holiday_give_day;
      this.comboShow.total_price =
        this.holidayMonthObj.real_price -
        0 +
        (this.formalMonthObj.real_price - 0);
      this.comboShow.original_price =
        this.holidayMonthObj.price -
        0 +
        (this.formalMonthObj.price - 0);
      this.comboShow.item_total_price = this.formalMonthObj.real_price;
      this.comboShow.holiday_total_price = this.holidayMonthObj.real_price;
      this.isCreate = true;
    },
    fnCreateXXSGiveList:function(){
      this.xxsGiveLists.push({
        subject_id: "",
        course_type: "",
        num: 0
      })
    },
    fnDeleteXXSData:function(index) {
      this.xxsGiveLists.splice(index,1)
    },
    fnFindCourseType:function(course_type){
        var index = Tool.findIndexInArryByKeyVal(this.xxsCourseLists, 'id', course_type)
        if (index>-1) {
          return this.xxsCourseLists[index].name
        }
        return ""
        
    },
    fnFindSubjectId:function(subject_id){
       var index = Tool.findIndexInArryByKeyVal(this.subjectLists, 'id', subject_id)
        if (index>-1) {
          return this.subjectLists[index].name
        }
        return ""
    }
  },
  watch: {
    formalMonthCost(val) {
      if (val == 1) {
        this.formalMonthObj.formal_month = "";
      } else {
        this.formalMonthObj.formal_day = "";
      }
    },
    holidayMonthCost(val) {
      if (val == 1) {
        this.holidayMonthObj.holiday_month = "";
      } else {
        this.holidayMonthObj.holiday_day = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nomal-combo {
  .data-form-title {
    font-size: 20px;
    margin-bottom: 30px;
    color: $color_black;
  }
  .self-table {
    .table-name {
      height: 60px;
      background-color: $color_blue;
      opacity: 0.7;
      line-height: 60px;
      color: #fff;
      text-align: center;
      font-size: 14px;
    }
    .el-button {
      margin-top: 40px;
    }
  }
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 20px;
      color: $color_black;
      .el-form-item__label {
        margin-right: 20px;
        padding-right: 0;
        &:before {
          color: $color_blue;
        }
      }
      i {
        font-style: normal;
        margin-left: 10px;
      }
      b {
        font-weight: normal;
        color: $color_normal;
      }
    }
    .el-input {
      width: 180px;
    }
    table {
      text-align: center;
      border-top: 1px solid #ebebeb;
      border-right: 1px solid #ebebeb;
      width: 95%;
      box-sizing: border-box;
      td {
        padding: 20px 0;
        border-left: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;
        .el-icon-question {
          margin: 0;
          width: auto;
          height: auto;
        }
        input {
          width: 60px;
          outline: none;
        }
        p {
          color: $color_normal;
          width: 130px;
          text-align: left;
          margin: 0 auto;
        }
        div {
          width: 130px;
          text-align: left;
          margin: 0 auto;
        }
      }
    }
  }
}

.xxs_preview {
  margin-top:10px;
  color:#333333;
}

.xxs-form-box {
    ::v-deep .el-form-item {
    .el-input {
      width: 100%!important;
    }
  }
  .wq_flex{
    margin-bottom:10px
  }
  .wq_flex::nth-child(n+1) {
    padding-left:20px
  }
}


.el-button {
  width: 120px;
  height: 40px;
}
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.wq_margin_auto {
  margin: auto;
}

.wq_flex_middle {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>
